import React, { Component } from "react";
import "./App.css";
import { Wizard } from "./components";
import ReactGA from "react-ga";
import { connect } from "react-redux";
import * as actions from "./store/actions/actions";
import headerAnalytics from "./utility/headerAnalytics";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import Qualified from "./components/Wizard/Steps/Qualified";
import { loadReCaptcha } from "react-recaptcha-v3";

import { browserHistory } from "./app-insights";

const DEFAULT_CONFIG = {
	trackingId: process.env.REACT_APP_GA_KEY,
	debug: process.env.REACT_APP_GA_DEBUG,
	gaOptions: {
		cookieDomain: "none",
	},
};
function loadNeuroIDScript() {
	return new Promise((resolve, reject) => {
		if (window.nid && typeof window.nid === "function") {
			window.nid("setLinkedSiteId", "form_pried507");
			resolve(window.nid);
			return;
		}

		const script = document.createElement("script");
		script.src = "//scripts.neuro-id.com/c/nid-aback859.js";
		script.async = true;
		script.onload = () => {
			if (window.nid && typeof window.nid === "function") {
				window.nid("setLinkedSiteId", "form_pried507");
				resolve(window.nid);
			} else {
				reject("NeuroID not initialized");
			}
		};
		script.onerror = () => reject("? Failed to load NeuroID script");

		document.head.appendChild(script);
	});
}

function loadThreatMetrixAdvanced(orgId, sessionId) {
	return new Promise((resolve, reject) => {
		const script = document.createElement("script");
		script.src = process.env.REACT_APP_TMX_SCRIPT_PATH;
		script.async = true;
		script.onload = () => {
			try {
				if (
					window.threatmetrix &&
					typeof window.threatmetrix.profile === "function"
				) {
					console.log(
						"? Advanced ThreatMetrix profiling called with:",
						orgId,
						sessionId,
					);
					window.threatmetrix.profile(
						"tm.republicfinance.com",
						orgId,
						sessionId,
					);
					resolve();
				} else {
					reject("ThreatMetrix profile function not available");
				}
			} catch (err) {
				reject("ThreatMetrix error: " + err);
			}
		};
		script.onerror = () => reject("? Failed to load tmx.js");

		document.head.appendChild(script);
	});
}

class App extends Component {
	constructor(props) {
		super(props);

		ReactGA.initialize([DEFAULT_CONFIG]);
		ReactGA.pageview("/apps/prequal/start");
	}

	async componentDidMount() {
		await this.props.bootstrapApp(headerAnalytics());
		loadReCaptcha(process.env.REACT_APP_RECAPTCHA_SITE);

		try {
			await loadNeuroIDScript();

			const orgId = "c6n1h26s";
			const sessionId = crypto.randomUUID();
			localStorage.setItem("threatmetrixSessionId", sessionId);

			await loadThreatMetrixAdvanced(orgId, sessionId);
		} catch (err) {}
		
	}

	render() {
		return (
			<Router basename={"/apps/prequal"} history={browserHistory}>
				<div className="App">
					<div className="pq-container">
						<Routes>
							<Route path="/" element={<Wizard />} />
							<Route path="/branchSelect/" element={<Navigate to="/" replace />} />
							<Route path="/branchSelect/:globalId" element={<Qualified />} />
							<Route path="/:id/*" element={<Wizard />} />
						</Routes>
					</div>
				</div>
			</Router>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	bootstrapApp: (data) => dispatch(actions.bootstrapApp(data)),
});

export default connect(null, mapDispatchToProps)(App);